const header = {

	elem: {
		menuItem: document.querySelectorAll('.nav-header-primary__item'),
		$menuToggle: $('.header__toggle-menu'),
		primaryNav: document.querySelectorAll('.nav-header-primary .br-toggle'),
		$searchForm: $('.search-form-desktop'),	
		$searchToggle: $('.header__toggle-search')
	},

	mql: {
		xlarge: window.matchMedia('(min-width: 1280px)')
	},
	
	init() {
		// Activate Accordions
		header.elem.primaryNav.forEach( function( element ) {
			element.toggle = Object.assign(new BRToggle(element, { accordion: true, navigation: 1280, open: false }));
		});

		$(document).on('click keydown', function(e) {		
			if(e.type === 'click') {
				if(!$(e.target).closest('#primary-navigation').length) {
					header.elem.primaryNav.forEach( function( element ) {
						element.toggle.closeAll();
					});
				}
			} else if (e.keyCode === 27) {
				header.elem.primaryNav.forEach( function( element ) {
					element.toggle.closeAll();
				});
			}
		});
		
		// Activate Search Slide-Out
		header.elem.$searchForm.find('input').attr('tabindex', '-1');
		header.elem.$searchForm.find('button').attr('tabindex', '-1');
		
		this.elem.$searchToggle.on('click', function(e) {
			e.preventDefault();
			$(e.target).attr({
				'aria-pressed': function (i, txt) {
					return (txt === 'false') ? 'true' : 'false';
				},
				'aria-label': function (i, txt) {
					return (txt === 'Open site search') ? txt.replace('Open', 'Close') : txt.replace('Close', 'Open');
				}
			});

			if($(e.target).attr('aria-pressed') === 'true'){
				header.elem.$searchForm.find('input').attr('tabindex', '0').focus();
				header.elem.$searchForm.find('button').attr('tabindex', '0');
			} else {
				header.elem.$searchForm.find('input').attr('tabindex', '-1');
				header.elem.$searchForm.find('button').attr('tabindex', '-1');
			}				
		});

		
		header.elem.$menuToggle.on('click', function(e) {
			e.preventDefault();
			$(e.target).attr({
				'aria-pressed': function (i, txt) {
					return (txt === 'false') ? 'true' : 'false';
				},
				'aria-label': function (i, txt) {
					return (txt === 'Open primary navigation') ? txt.replace('Open', 'Close') : txt.replace('Close', 'Open');
				}
			});
			$(e.target).find('.show-for-sr').html($(e.target).attr('aria-label'));
			$('html, body').toggleClass('body--no-scroll');	
		});

		$(window).on('resize', this.reset.bind(this));
	},

	hoveron(event) {
		if(header.mql.xlarge.matches) {
			let parent = event.target.parentNode;
			let target = event.target.querySelector('.br-toggle__button').id;
			if ((parent !== null) && (target !== null)) {
				parent.toggle.open('#' + target);
			}
		}
	},

	hoveroff(event) {
		if(header.mql.xlarge.matches) {
			event.target.toggle.closeAll();
		}
	},

	reset() {
		if(header.mql.xlarge.matches) {
			$('html, body').removeClass('body--no-scroll');						
			header.elem.$menuToggle.attr({
				'aria-pressed': 'false',
				'aria-label': 'Open primary navigation'
			});
			header.elem.$menuToggle.find('.show-for-sr').html(header.elem.$menuToggle.attr('aria-label'));
		}
	}
};

export { header };
